export default "__VITE_ASSET__CCjFataZ__"